import { MediaFactory } from './factory';

module.exports = new MediaFactory();
